(function ($) {
    /**
     *
     * @returns {*}
     */
    $.fn.productionPallet = function (production, data = null) {
        return this.each(function () {
            let pallet = this;
            pallet.production = production;

            pallet.boxes = new Set();
            pallet.boxesContainer = null;
            pallet.btnDelete = null;
            pallet.btnNewBox = null;
            pallet.btnSave = null;
            pallet.btnShowPallet = null;
            pallet.fieldGrossWeight = null;
            pallet.fieldMeasurements = null;
            pallet.fieldStackable = null;
            pallet.form = null;
            pallet.grossWeight = null;
            pallet.identifier = null;
            pallet.measurements = null;
            pallet.palletId = null;
            pallet.palletShowForm = null;
            pallet.showNumber = null;
            pallet.titleContainer = null;

            /**
             *
             */
            pallet.init = (data) => {
                pallet.initData();
                pallet.initElements();
                pallet.initButtons();
                pallet.setFields();
                pallet.setData(data);
                pallet.postInit();
            }

            /**
             *
             */
            pallet.initData = () => {
                pallet.identifier = crypto.randomUUID();
            }

            /**
             *
             */
            pallet.initButtons = () => {
                pallet.btnNewBox.off('click keydown').on('click keydown', () => {
                    pallet.newBox();
                    window.blur();
                });

                pallet.btnSave.off('click keydown').on('click keydown', () => {
                    pallet.save();
                    window.blur();
                });

                pallet.btnShowPallet.off('click keydown').on('click keydown', () => {
                    if (pallet.palletShowForm.css('display') === 'none') {
                        pallet.palletShowForm.slideDown()
                        pallet.titleContainer.slideDown();
                        pallet.showTitle();
                    } else {
                        pallet.palletShowForm.slideUp()
                        pallet.titleContainer.slideUp();
                    }
                });

                pallet.btnDelete.off('click keydown').on('click keydown', (event) => {
                    event.stopPropagation();
                    event.preventDefault();
                    pallet.delete(event);
                });
            }

            /**
             *
             */
            pallet.showTitle = () => {
                pallet.production.palletsTitle.slideDown();
                pallet.titleContainer.slideDown();
            }

            /**
             *
             */
            pallet.initElements = () => {
                pallet.form = $('form.pallet-form', $(pallet));
                pallet.boxesContainer = $('div.production-boxes', $(pallet));
                pallet.btnDelete = $('i.sf-delete.pallet-delete', $(pallet));
                pallet.btnNewBox = $('button.new-box', $(pallet));
                pallet.btnSave = $('button.pallet-save', $(pallet));
                pallet.btnShowPallet = $('button.pallet-show', $(pallet));
                pallet.fieldGrossWeight = $('[name="gross_weight"]', pallet.form);
                pallet.fieldMeasurements = $('[name="measurements"]', pallet.form);
                pallet.fieldStackable = $('[name="stackable"]', pallet.form);
                pallet.palletShowForm = $('.pallet-show-form-container', $(pallet));
                pallet.showNumber = $('span.pallet-no', $(pallet));
                pallet.titleContainer = $('.pallet-title', $(pallet));
            }

            /**
             *
             */
            pallet.newBox = (data = null) => {
                pallet.boxes.forEach((box) => {
                    box.accordion.close();
                });
                let template = $('#box-template').html();
                let newElement = $(template).appendTo(pallet.boxesContainer);
                let box = newElement.productionBox(this, data);
                pallet.boxes.add(box);
                setTimeout(() => {
                    box.setNumber();
                    // TODO: Make permanent fix to prevent event loop which causes 300+ API calls
                    // $('[name="spool_weight"]', box).focus();
                }, 200);
            }

            /**
             *
             * @param callback
             */
            pallet.save = (callback) => {
                pallet.setGrossWeight(pallet.fieldGrossWeight.val());
                pallet.setMeasurements(pallet.fieldMeasurements.val());
                pallet.setStackable(pallet.fieldStackable.is(':checked'));
                if (pallet.getGrossWeight() > 0) {
                    $.ajax({
                        type: "POST",
                        url: '/admin/pallet/store',
                        data: pallet.getData(),
                        dataType: "json",
                        encode: true,
                        success: function (response) {
                            pallet.setPalletId(response.pallet_id);

                            if (callback) {
                                callback();
                            }
                        },
                        error: function (response) {
                            if (response.error !== undefined) {
                                alert(response.error);
                            } else {
                                alert(JSON.parse(response.responseText).message);
                            }
                        }
                    })
                }
            }

            /**
             *
             */
            pallet.setFields = () => {
                pallet.setGrossWeight();
                pallet.setMeasurements();
                pallet.setStackable();
            }

            /**
             *
             */
            pallet.postInit = () => {
                if ((pallet.fieldGrossWeight.val() > 0) || (pallet.fieldMeasurements.val() > 0)) {
                    pallet.palletShowForm.slideDown();
                }

                pallet.accordion = $(this).productionAccordion(
                    $('> .title.folder-open', $(pallet)),
                    $('.pallet-container,.pallet-container-boxes-card', $(pallet))
                );

                $(pallet).productionAccordion(
                    $('.boxes-card > .title.folder-open', $(pallet)),
                    $('.boxes-card .production-boxes', $(pallet))
                );

                if (pallet.getGrossWeight() > 0) {
                    pallet.production.palletsTitle.slideDown();
                }

                pallet.setNumber();
            }

            /**
             *
             * @returns {{product_id: *, sales_order_id: *, gross_weight: *, pallet_id: *, measurements: *}}
             */
            pallet.getData = () => {
                return {
                    gross_weight: pallet.getGrossWeight(),
                    measurements: pallet.getMeasurements(),
                    stackable: pallet.getStackable() ? 1 : 0,
                    pallet_id: pallet.getPalletId(),
                    batch_id: pallet.production.getBatchId(),
                    product_id: pallet.getProductId(),
                    sales_order_line_id: pallet.getSalesOrderLineId(),
                };
            }

            /**
             *
             * @returns {null|number|*}
             */
            pallet.getGrossWeight = () => {
                return pallet.grossWeight;
            }

            /**
             *
             * @returns {number}
             */
            pallet.getIndex = () => {
                let pallets = pallet.production.getPallets();
                let i = 1;
                let index = null;
                pallets.forEach(function (loopPallet) {
                    if (pallet.identifier === loopPallet.identifier) {
                        index = i;
                    }
                    i++;
                });
                return (index ?? i);
            }

            /**
             *
             * @returns {null|*}
             */
            pallet.getMeasurements = () => {
                return pallet.measurements;
            }

            /**
             *
             * @returns {null|boolean|*}
             */
            pallet.getStackable = () => {
                return pallet.stackable;
            }

            /**
             *
             * @returns {null|number|*}
             */
            pallet.getPalletId = () => {
                return pallet.palletId;
            }

            /**
             *
             * @returns {*}
             */
            pallet.getProductId = () => {
                return pallet.production.getProductId();
            }

            /**
             *
             * @returns {*}
             */
            pallet.getSalesOrderId = () => {
                return pallet.production.getSalesOrderId();
            }

            /**
             *
             * @returns {*}
             */
            pallet.getSalesOrderLineId = () => {
                return pallet.production.getSalesOrderLineId();
            }

            /**
             *
             * @param data
             */
            pallet.setData = (data) => {
                if (data !== null) {
                    pallet.setPalletId(data.pallet_id);
                    pallet.setGrossWeight(data.gross_weight);
                    pallet.setMeasurements(data.measurements);
                    pallet.setStackable(data.stackable);
                    $.each(data.boxes, function (foo, box) {
                        pallet.newBox(box);

                    })
                    pallet.setPickedStatus(data?.picked);
                } else {
                    // pallet.newBox();
                }
            }

            /**
             *
             * @param gross_weight
             */
            pallet.setGrossWeight = (gross_weight) => {
                pallet.grossWeight = gross_weight;
                pallet.fieldGrossWeight.val(pallet.grossWeight);
            }

            /**
             *
             * @param measurements
             */
            pallet.setMeasurements = (measurements) => {
                pallet.measurements = measurements;
                pallet.fieldMeasurements.val(pallet.measurements);
            }

            /**
             *
             * @param stackable
             */
            pallet.setStackable = (stackable = false) => {
                pallet.stackable = (stackable === true || stackable === 1 || stackable === '1');
                pallet.fieldStackable.prop('checked', pallet.stackable);
            }

            /**
             *
             */
            pallet.setNumber = () => {
                $('span.pallet-no', $(pallet)).text(pallet.getIndex());
            }

            pallet.setPickedStatus = (picked) => {
                pallet.picked = (picked === true || picked === 1 || picked === '1');
                const container = $(pallet);
                if (pallet.picked) {
                    pallet.btnSave.prop('disabled', true).addClass('disabled');
                    pallet.btnNewBox.prop('disabled', true).addClass('disabled');
                    pallet.btnDelete.prop('disabled', true).addClass('disabled');
                    pallet.fieldGrossWeight.prop('disabled', true);
                    pallet.fieldMeasurements.prop('disabled', true);
                    pallet.fieldStackable.prop('disabled', true);
                    $('i.sf-delete.pallet-delete', container).css('display', 'none');
                    $('.background-pallet', container).addClass('disabled');
                    $('.picked-message-row', container).removeClass('d-none');
                } else {
                    pallet.btnSave.prop('disabled', false).removeClass('disabled');
                    pallet.btnNewBox.prop('disabled', false).removeClass('disabled');
                    pallet.btnDelete.prop('disabled', false).removeClass('disabled');
                    pallet.fieldGrossWeight.prop('disabled', false);
                    pallet.fieldMeasurements.prop('disabled', false);
                    pallet.fieldStackable.prop('disabled', false);
                    $('i.sf-delete.pallet-delete', container).css('display', 'inline-block');
                    $('.background-pallet', container).removeClass('disabled');
                    $('.picked-message-row', container).addClass('d-none');
                }

                // Cascade to child boxes (and their spools). Use fromParent=true so we don't overwrite child state.
                pallet.boxes.forEach(function (box) {
                    if (!box) { return; }
                    box.setPickedStatus(pallet.picked, true);
                });
            }

            /**
             *
             */
            pallet.setPalletId = (pallet_id) => {
                pallet.palletId = parseInt(pallet_id);
                pallet.btnDelete.css('display', 'inline-block');
            }

            /**
             *
             */
            pallet.delete = () => {
                confirm('Verwijderen?', () => {
                    $.ajax({
                        type: "DELETE",
                        url: '/admin/pallets/' + pallet.getPalletId(),
                        encode: true,
                        success: function () {
                            pallet.production.deletePallet(pallet);
                        },
                        error: function (response) {
                            if (response.error !== undefined) {
                                alert(response.error);
                            } else {
                                alert(JSON.parse(response.responseText).message);
                            }
                            return false;
                        }
                    })
                }, null);
            }

            /**
             *
             * @param boxToRemove
             */
            pallet.deleteBox = (boxToRemove) => {
                pallet.boxes.forEach((box) => {
                    if (box === boxToRemove) {
                        box.remove();
                        pallet.boxes.delete(box);
                    }
                })
            }

            pallet.init(data);

            return pallet;
        })[0];
    }
}(jQuery));
